import { render, staticRenderFns } from "./add_Column.vue?vue&type=template&id=5fa19c0c&style=true"
import script from "./add_Column.vue?vue&type=script&lang=js"
export * from "./add_Column.vue?vue&type=script&lang=js"
import style0 from "./add_Column.vue?vue&type=style&index=0&id=5fa19c0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports